if (!customElements.get('tuzex-google-reviews')) {
  customElements.define('tuzex-google-reviews', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        const slides = [...this.querySelectorAll('.tuzex-google__slide')];
        const controls = this.querySelector('.tuzex-google__controls');
        let active = 0;
        const update = () => {
          slides.forEach((slide, index) => { slide.hidden = index !== active; });
          this.querySelector('[data-review-position]').textContent = `${active + 1} / ${slides.length}`;
        };
        if (!slides.length) return;
        controls.hidden = slides.length < 2;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          active = (active + Number(button.dataset.step) + slides.length) % slides.length;
          update();
        }, { signal: this.abort.signal }));
        update();
      });
    }
    disconnectedCallback() { this.abort.abort(); }
  });
}
